import { captureSession, getClient, getCurrentScope, startSession } from '@sentry/browser';
import { isNonProductionEnvironment } from '@glomopay/utils';

import { isPiiLikeUserId } from './is-pii-user-id';

/**
 * Rotates the active Sentry session so that a session envelope is emitted with the
 * current scope's user as `did`. Identity changes that happen before `Sentry.init()`
 * must not disturb the initial session created by `browserSessionIntegration`, so this
 * is a no-op until a Sentry client is active.
 */
const rotateSentrySession = () => {
  if (!getClient()) {
    return;
  }

  startSession();
  captureSession();
};

export const setSentryUser = (id: string) => {
  if (isPiiLikeUserId(id)) {
    if (isNonProductionEnvironment()) {
      console.warn('[Sentry] Ignoring PII-shaped user id; user not set.');
    }
    return;
  }

  getCurrentScope().setUser({ id });
  rotateSentrySession();
};

export const clearSentryUser = () => {
  getCurrentScope().setUser(null);
  rotateSentrySession();
};
